import {createSlice} from "@reduxjs/toolkit";

const genericErrorPageSlice = createSlice({
    name: "genericErrorPage",
    initialState: null,
    reducers:{
        setGenericErrorPage: (state, action) =>{       
            if (!action.payload)
                return null;

            return ({...action.payload});
        },
        clearGenericError: (state, action) => null
    }
});

export const {setGenericErrorPage, clearGenericError} = genericErrorPageSlice.actions;

export default genericErrorPageSlice.reducer;
